import { service } from '../../../../helpers/http' 

export const ActionGetPlans = ({ dispatch }, payload) => { 
    return service({
        module: 'plan',
        action: 'getPlans',
        payload: payload
    })
}

export const ActionPostPlans = ({ dispatch }, payload) => {

    return service({
        module: 'plan',
        action: 'postPlans',
        payload: payload
    })
    
}

export const ActionPutPlans = ({ dispatch }, payload) => {

    return service({
        module: 'plan',
        action: 'putPlans',
        payload: payload
    })
    
}

export const ActionDeletePlans = ({ dispatch }, payload) => {

    return service({
        module: 'plan',
        action: 'deletePlans',
        payload: payload
    })
    
}
